/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const utilsModule = require('@utils/enerveeUtilsModule');

/**
 * Module for handling fast track code.
 */
const accountModule = angular.module('enervee.account', [
    utilsModule.name,
]);

module.exports = accountModule;